// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-specific styles */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: clamp(1rem, 3vw, 2.5rem);
  box-sizing: border-box;
}

.app-shell {
  width: 100%;
}

.nav-tabs {
  margin-bottom: 20px;
}

.tab-content {
  padding: 20px 0;
}

.alert {
  margin-top: 20px;
}

/* Results display styles */
.json-type-container,
.json-type-container-workflow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  margin: 0 auto 1rem;
  padding: 0;
  width: 100%;
  text-align: center;
}

.json-type-badge,
.workflow-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.08);
  color: #0f172a;
}

.results-display {
  margin-top: 20px;
}

.summary-section,
.remarks-section,
.metadata-section {
  margin-bottom: 30px;
}

/* Documentation page styles */
.documentation-page {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.doc-table__code-cell {
  white-space: nowrap;
  padding-right: 1.25rem;
  vertical-align: top;
}

.doc-table__description-cell {
  padding-left: 0.75rem;
}

.doc-remark-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 0.75rem;
}

.doc-remark-message {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  flex: 1;
  min-width: 0;
}

.doc-remark-text {
  flex: 1;
  min-width: 0;
  line-height: 1.35;
}

.doc-remark-code {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  height: 2.1rem;
  border-radius: 0.6rem;
  margin-left: 0;
}

.remarks-section .list-group-item {
  padding: 0.65rem 0.85rem;
}

.doc-info-tooltip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 0.5rem;
  color: #6c757d;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s ease;
}

.doc-info-tooltip:hover,
.doc-info-tooltip:focus-visible {
  color: #0d6efd;
}

.app-header .doc-info-tooltip {
  color: #ffffff;
}

.app-header .doc-info-tooltip:hover,
.app-header .doc-info-tooltip:focus-visible {
  color: #e2e8f0;
}

.doc-remark-tooltip {
  margin-left: 0;
}

.btn-primary-soft {
  color: #fff !important;
  font-weight: 600;
  transition: filter 0.2s ease, transform 0.2s ease;
}

.btn-primary-soft:hover,
.btn-primary-soft:focus-visible {
  color: #fff !important;
  filter: brightness(1.08);
  transform: translateY(-1px);
}

.btn-primary-soft:focus-visible {
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.3);
}

.tooltip-white .tooltip-inner {
  background-color: #ffffff;
  color: #1f2937;
  border: 1px solid rgba(15, 23, 42, 0.15);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}

.tooltip-white.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before,
.tooltip-white.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #ffffff;
}

.tooltip-white.bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before,
.tooltip-white.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #ffffff;
}

.tooltip-white.bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before,
.tooltip-white.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #ffffff;
}

.tooltip-white.bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before,
.tooltip-white.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #ffffff;
}

/* Floating documentation overlay */
.docs-overlay-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(12px, 4vw, 40px);
  z-index: 1400;
}

.docs-overlay {
  width: min(1100px, 100%);
  max-height: calc(100vh - clamp(48px, 8vh, 120px));
  max-height: calc(100dvh - clamp(48px, 8vh, 120px));
  display: flex;
  flex-direction: column;
  padding: clamp(1rem, 2vw, 1.75rem);
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.25);
}

.docs-overlay--fullscreen {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  border-radius: 0;
  padding: clamp(1rem, 2vw, 2rem);
  align-self: stretch;
}

.docs-overlay__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.docs-overlay__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.docs-overlay__eyebrow {
  letter-spacing: 0.08em;
  font-size: 0.65rem;
}

.docs-overlay__title {
  font-size: 1.35rem;
  font-weight: 600;
}

/* Forgery tests */
.forgery-section {
  width: 100%;
}

.forgery-section .card {
  border: 1px solid rgba(31, 23, 86, 0.08);
  height: 100%;
}

.forgery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  align-items: stretch;
  justify-items: stretch;
  grid-auto-rows: 1fr;
}

.forgery-card {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 0.75rem;
  padding: 1rem;
  background: #f8fafc;
  min-height: 160px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  height: 100%;
  color: #0f172a;
}

.forgery-card--alert {
  border-color: rgba(220, 38, 38, 0.35);
  background: #fff5f5;
  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.12);
  color: #0f172a;
}

.forgery-card__title {
  font-size: 1rem;
  font-weight: 600;
}

.forgery-card__status {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.forgery-card__result {
  margin-top: 0.5rem;
}

.forgery-card__type {
  color: #334155;
}

.forgery-detail-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 1300;
}

.forgery-detail-card {
  max-width: 520px;
  width: min(520px, 100%);
  background: #ffffff;
  color: #0f172a;
  padding: 1.25rem;
  border: 1px solid rgba(15, 23, 42, 0.12);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.2);
  border-radius: 0.9rem;
  line-height: 1.5;
}

.doc-forgery-table td {
  text-align: center;
  vertical-align: middle;
}
.doc-forgery-table th {
  text-align: center;
}

.doc-forgery-table tbody td:first-child {
  font-weight: 600;
}

.doc-forgery-entry {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  margin: 0 auto;
  max-width: 45ch;
  color: inherit;
  line-height: 1.35;
}

.doc-forgery-entry--title {
  font-weight: 600;
  color: #0f172a;
}

.doc-code-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  padding: 0.2rem 0.6rem;
  border-radius: 0.65rem;
  font-weight: 600;
  background-color: #0d6efd;
  color: #ffffff !important;
}

.doc-code-badge--ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.45rem;
  border-radius: 999px;
  font-size: 0.75rem;
  text-transform: none;
  background-color: rgba(15, 23, 42, 0.08);
  color: #0f172a;
  text-align: center;
  white-space: normal;
}

.doc-code-badge--ghost .doc-forgery-entry {
  display: -webkit-box;
  width: 100%;
}

/* Forgery tab badges should stay legible on blue backgrounds */
.doc-forgery-table .doc-code-badge--ghost {
  background-color: #0d6efd;
  color: #ffffff !important;
}

.doc-forgery-table .doc-forgery-entry--title {
  color: #ffffff;
}

.docdata-preformatted {
  background: #f8fafc;
  border-radius: 0.4rem;
  padding: 0.35rem 0.5rem;
  font-size: 0.85em;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
}

.doc-forgery-search .input-group-text {
  background: #f8fafc;
}

.doc-forgery-search small {
  display: inline-block;
  margin-top: 0.4rem;
}

.doc-tabs .nav-link {
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  text-align: center;
}

.token-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
  align-items: stretch;
}

.token-info-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.token-info-items {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
}

.token-info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.instructions-modal .modal-body {
  text-align: center;
}

.instructions-modal .modal-title {
  width: 100%;
  text-align: center;
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .docs-overlay-backdrop {
    padding: clamp(8px, 4vw, 16px);
  }

  .docs-overlay {
    width: 100%;
    height: 100%;
    max-height: none;
    border-radius: 0.75rem;
    padding: clamp(1rem, 3vw, 1.5rem);
  }

  .docs-overlay--fullscreen {
    border-radius: 0;
  }
}

@media (max-width: 576px) {
  .forgery-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,OAAO;EACP,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;;EAEE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;EACjD,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;EAC7C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* App-specific styles */\r\n.container {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: clamp(1rem, 3vw, 2.5rem);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.app-shell {\r\n  width: 100%;\r\n}\r\n\r\n.nav-tabs {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.tab-content {\r\n  padding: 20px 0;\r\n}\r\n\r\n.alert {\r\n  margin-top: 20px;\r\n}\r\n\r\n/* Results display styles */\n.json-type-container,\n.json-type-container-workflow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  margin: 0 auto 1rem;\n  padding: 0;\n  width: 100%;\n  text-align: center;\n}\n\r\n.json-type-badge,\r\n.workflow-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  padding: 0.35rem 0.65rem;\r\n  border-radius: 999px;\r\n  background: #f8fafc;\r\n  border: 1px solid rgba(15, 23, 42, 0.08);\r\n  color: #0f172a;\r\n}\r\n\r\n.results-display {\r\n  margin-top: 20px;\r\n}\r\n\r\n.summary-section,\r\n.remarks-section,\r\n.metadata-section {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n/* Documentation page styles */\r\n.documentation-page {\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.doc-table__code-cell {\r\n  white-space: nowrap;\r\n  padding-right: 1.25rem;\r\n  vertical-align: top;\r\n}\r\n\r\n.doc-table__description-cell {\r\n  padding-left: 0.75rem;\r\n}\r\n\r\n.doc-remark-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.doc-remark-message {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.35rem;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.doc-remark-text {\r\n  flex: 1;\r\n  min-width: 0;\r\n  line-height: 1.35;\r\n}\r\n\r\n.doc-remark-code {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 2.5rem;\r\n  height: 2.1rem;\r\n  border-radius: 0.6rem;\r\n  margin-left: 0;\r\n}\r\n\r\n.remarks-section .list-group-item {\r\n  padding: 0.65rem 0.85rem;\r\n}\r\n\r\n.doc-info-tooltip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  margin-left: 0.5rem;\r\n  color: #6c757d;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.doc-info-tooltip:hover,\r\n.doc-info-tooltip:focus-visible {\r\n  color: #0d6efd;\r\n}\r\n\r\n.app-header .doc-info-tooltip {\r\n  color: #ffffff;\r\n}\r\n\r\n.app-header .doc-info-tooltip:hover,\r\n.app-header .doc-info-tooltip:focus-visible {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.doc-remark-tooltip {\r\n  margin-left: 0;\r\n}\r\n\r\n.btn-primary-soft {\r\n  color: #fff !important;\r\n  font-weight: 600;\r\n  transition: filter 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.btn-primary-soft:hover,\r\n.btn-primary-soft:focus-visible {\r\n  color: #fff !important;\r\n  filter: brightness(1.08);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-primary-soft:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.3);\r\n}\r\n\r\n.tooltip-white .tooltip-inner {\r\n  background-color: #ffffff;\r\n  color: #1f2937;\r\n  border: 1px solid rgba(15, 23, 42, 0.15);\r\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\r\n}\r\n\r\n.tooltip-white.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\r\n.tooltip-white.bs-tooltip-top .tooltip-arrow::before {\r\n  border-top-color: #ffffff;\r\n}\r\n\r\n.tooltip-white.bs-tooltip-auto[data-popper-placement^=\"bottom\"] .tooltip-arrow::before,\r\n.tooltip-white.bs-tooltip-bottom .tooltip-arrow::before {\r\n  border-bottom-color: #ffffff;\r\n}\r\n\r\n.tooltip-white.bs-tooltip-auto[data-popper-placement^=\"left\"] .tooltip-arrow::before,\r\n.tooltip-white.bs-tooltip-start .tooltip-arrow::before {\r\n  border-left-color: #ffffff;\r\n}\r\n\r\n.tooltip-white.bs-tooltip-auto[data-popper-placement^=\"right\"] .tooltip-arrow::before,\r\n.tooltip-white.bs-tooltip-end .tooltip-arrow::before {\r\n  border-right-color: #ffffff;\r\n}\r\n\r\n/* Floating documentation overlay */\r\n.docs-overlay-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  backdrop-filter: blur(6px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: clamp(12px, 4vw, 40px);\r\n  z-index: 1400;\r\n}\r\n\r\n.docs-overlay {\r\n  width: min(1100px, 100%);\r\n  max-height: calc(100vh - clamp(48px, 8vh, 120px));\r\n  max-height: calc(100dvh - clamp(48px, 8vh, 120px));\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: clamp(1rem, 2vw, 1.75rem);\r\n  border-radius: 1rem;\r\n  background: #ffffff;\r\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.25);\r\n}\r\n\r\n.docs-overlay--fullscreen {\r\n  width: 100%;\r\n  height: 100%;\r\n  max-width: none;\r\n  max-height: none;\r\n  border-radius: 0;\r\n  padding: clamp(1rem, 2vw, 2rem);\r\n  align-self: stretch;\r\n}\r\n\r\n.docs-overlay__header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.docs-overlay__body {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.docs-overlay__eyebrow {\r\n  letter-spacing: 0.08em;\r\n  font-size: 0.65rem;\r\n}\r\n\r\n.docs-overlay__title {\r\n  font-size: 1.35rem;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Forgery tests */\r\n.forgery-section {\r\n  width: 100%;\r\n}\r\n\r\n.forgery-section .card {\r\n  border: 1px solid rgba(31, 23, 86, 0.08);\r\n  height: 100%;\r\n}\r\n\r\n.forgery-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 1rem;\r\n  align-items: stretch;\r\n  justify-items: stretch;\r\n  grid-auto-rows: 1fr;\r\n}\r\n\r\n.forgery-card {\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 0.75rem;\n  padding: 1rem;\n  background: #f8fafc;\n  min-height: 160px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  height: 100%;\n  color: #0f172a;\n}\n\n.forgery-card--alert {\n  border-color: rgba(220, 38, 38, 0.35);\n  background: #fff5f5;\n  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.12);\n  color: #0f172a;\n}\n\r\n.forgery-card__title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.forgery-card__status {\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.forgery-card__result {\n  margin-top: 0.5rem;\n}\n\n.forgery-card__type {\n  color: #334155;\n}\n\n.forgery-detail-overlay {\n  position: fixed;\n  inset: 0;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  backdrop-filter: blur(3px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1rem;\r\n  z-index: 1300;\r\n}\r\n\r\n.forgery-detail-card {\n  max-width: 520px;\n  width: min(520px, 100%);\n  background: #ffffff;\n  color: #0f172a;\n  padding: 1.25rem;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.2);\n  border-radius: 0.9rem;\n  line-height: 1.5;\n}\n\r\n.doc-forgery-table td {\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n.doc-forgery-table th {\r\n  text-align: center;\r\n}\r\n\r\n.doc-forgery-table tbody td:first-child {\r\n  font-weight: 600;\r\n}\r\n\r\n.doc-forgery-entry {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-align: center;\r\n  margin: 0 auto;\r\n  max-width: 45ch;\r\n  color: inherit;\r\n  line-height: 1.35;\r\n}\r\n\r\n.doc-forgery-entry--title {\r\n  font-weight: 600;\r\n  color: #0f172a;\r\n}\r\n\r\n.doc-code-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 2.5rem;\r\n  padding: 0.2rem 0.6rem;\r\n  border-radius: 0.65rem;\r\n  font-weight: 600;\r\n  background-color: #0d6efd;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.doc-code-badge--ghost {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.2rem 0.45rem;\r\n  border-radius: 999px;\r\n  font-size: 0.75rem;\r\n  text-transform: none;\r\n  background-color: rgba(15, 23, 42, 0.08);\r\n  color: #0f172a;\r\n  text-align: center;\r\n  white-space: normal;\r\n}\r\n\r\n.doc-code-badge--ghost .doc-forgery-entry {\r\n  display: -webkit-box;\r\n  width: 100%;\r\n}\r\n\r\n/* Forgery tab badges should stay legible on blue backgrounds */\r\n.doc-forgery-table .doc-code-badge--ghost {\r\n  background-color: #0d6efd;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.doc-forgery-table .doc-forgery-entry--title {\r\n  color: #ffffff;\r\n}\r\n\r\n.docdata-preformatted {\r\n  background: #f8fafc;\r\n  border-radius: 0.4rem;\r\n  padding: 0.35rem 0.5rem;\r\n  font-size: 0.85em;\r\n  margin: 0;\r\n  white-space: pre-wrap;\r\n  word-break: break-all;\r\n}\r\n\r\n.doc-forgery-search .input-group-text {\r\n  background: #f8fafc;\r\n}\r\n\r\n.doc-forgery-search small {\r\n  display: inline-block;\r\n  margin-top: 0.4rem;\r\n}\r\n\r\n.doc-tabs .nav-link {\r\n  color: #0f172a;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.35rem;\r\n  text-align: center;\r\n}\r\n\r\n.token-info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n  gap: 1rem;\r\n  align-items: stretch;\r\n}\r\n\r\n.token-info-section {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.token-info-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n  flex: 1;\r\n}\r\n\r\n.token-info-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.instructions-modal .modal-body {\r\n  text-align: center;\r\n}\r\n\r\n.instructions-modal .modal-title {\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding: 10px;\r\n  }\r\n\r\n  .docs-overlay-backdrop {\r\n    padding: clamp(8px, 4vw, 16px);\r\n  }\r\n\r\n  .docs-overlay {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-height: none;\r\n    border-radius: 0.75rem;\r\n    padding: clamp(1rem, 3vw, 1.5rem);\r\n  }\r\n\r\n  .docs-overlay--fullscreen {\r\n    border-radius: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .forgery-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
